
(function ($) {
  ///////////////////////////////////////////////////////////////////////////
  //effect On Scroll 1.0
  ///////////////////////////////////////////////////////////////////////////
  //
  //  '.yourClass' is the element you would like .nonStick and .stick classs be added to
  /////////////////////////////////////////////////////////////////////
  //                                                                //
  //  $('.yourClass').effectOnScroll({                              //
  //      detectDistance: 200 // default is 0                       //
  //      pushContentDown: true // default is false                 //
  //      fixed: true, // default is false                          //
  //      contentToPush: "main" //default the next element below    //
  //  });                                                          //
  //                                                               //
  ///////////////////////////////////////////////////////////////////
  //

  $.fn.effectOnScroll = function (options, callback) {

    var settings = $.extend({
      detectDistance: " ",
      pushContentDown: false,
      contentToPush: $(elem).next(),
      fixed: true
    }, options)


    //the element selected	
    var elem ;
    $(this).each(function (elem) {
      //add topstop	
      elem = $(this);

      elem.before('<div class="topstop"></div>');
      elem.addClass('scroll-off');
      elem.addClass('scrolling-target');
      //sticky function
      function sticky_element() {
        var window_top = theWindow.scrollTop() + (settings.detectDistance) * 1000;
        var footer_top = $("footer").offset().bottom;
        var div_top_fixed = elem.prev().offset().top;
        var div_top = elem.offset().top;
        var div_height = elem.outerHeight();
        var stickyArea = elem;
        var mainbody = settings.contentToPush;
   

        if (settings.fixed == true) {
          if (window_top + div_height > footer_top) {
            $(stickyArea).css({
              top: (window_top + div_height - footer_top) * 1
            })
          } else if (window_top > div_top_fixed) {
            $(stickyArea).removeClass('scroll-off')
            $(stickyArea).addClass('scroll-on')
            if (settings.pushContentDown == true) {
              $(mainbody).css({
                'padding-top': div_height
              })
            } else {
              $(mainbody).css({
                'padding-top': '0'
              })
            }
          } else {
            $(stickyArea).removeClass('scroll-on')
            $(stickyArea).addClass('scroll-off')
            $(mainbody).css({
              'padding-top': '0'
            })
          }
        } else {
          if (window_top + div_height > footer_top) {
            $(stickyArea).css({
              top: (window_top + div_height - footer_top) * 1
            })
          } else if (window_top > div_top) {
            $(stickyArea).removeClass('scroll-off')
            $(stickyArea).addClass('scroll-on')
            if (settings.pushContentDown == true) {
              $(mainbody).css({
                'padding-top': div_height
              })
            } else {
              $(mainbody).css({
                'padding-top': 'auto'
              })
            }
          } else {
            $(stickyArea).removeClass('scroll-on')
            $(stickyArea).addClass('scroll-off')
            $(mainbody).css({
              'padding-top': '0'
            })
          }
        }
      }
      //run functions

      if ($(this).length === 1) {


        theWindow.on('load scroll window:resize', function () {
          sticky_element();

        });

        $('body').on('load scroll window:resize', function () {
          sticky_element();

        });


      }

    });

    if (typeof callback == 'function') { // make sure the callback is a function
      callback.call(this); // brings the scope to the callback
    }
  }

  ///////////////////////////////////////////////////////////////////////////
  //effectOnScroll 1.0 end
  ///////////////////////////////////////////////////////////////////////////


})(jQuery); // or even jQuery.noConflict()